import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const TYPES_CAM = ["Dôme","Bullet","PTZ","Thermique grand angle","Fisheye","Intérieure","Extérieure"];

export default function ZonesCameras({ T, intervention, onClose }) {
  const [cameras, setCameras] = useState(
    Array.from({length:8},(_,i)=>({numero_camera:i+1,zone:"",localisation:"",type_camera:"",ip:"",hdcvi:false,notes:""}))
  );
  const [saving, setSaving] = useState(false);
  const [saved, setSaved]   = useState(false);

  useEffect(()=>{
    fetch(`${BASE}/zones/${intervention.id}/cameras`,{headers:h()}).then(r=>r.json()).then(data=>{
      if (data?.length>0) {
        setCameras(prev=>prev.map((c,i)=>data.find(d=>d.numero_camera===i+1)||c));
      }
    }).catch(()=>{});
  },[]);

  const upCam = (idx,key,val) => setCameras(p=>p.map((c,i)=>i===idx?{...c,[key]:val}:c));

  const save = async () => {
    setSaving(true);
    const toSave = cameras.filter(c=>c.zone||c.localisation||c.ip);
    await fetch(`${BASE}/zones/${intervention.id}/cameras`,{
      method:"POST",headers:h(),body:JSON.stringify({cameras:toSave})
    });
    setSaving(false); setSaved(true);
    setTimeout(()=>setSaved(false),2000);
  };

  const nbRemplis = cameras.filter(c=>c.zone||c.localisation).length;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1001,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,width:"90%",animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",maxWidth:900,maxHeight:"92vh",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"16px 22px 12px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:T.text}}>📷 Fiche Caméras — Pack Sentinelle</div>
            <div style={{fontSize:12,color:T.muted,marginTop:2}}>{intervention.titre} · {nbRemplis} / {cameras.length} caméras renseignées</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setCameras(p=>[...p,{numero_camera:p.length+1,zone:"",localisation:"",type_camera:"",ip:"",hdcvi:false,notes:""}])}
              style={{padding:"8px 12px",borderRadius:9,background:"#10b98115",border:"1px solid #10b98130",color:"#10b981",fontSize:13,fontWeight:700,cursor:"pointer"}}>+ Caméra</button>
            <button onClick={()=>cameras.length>1&&setCameras(p=>p.slice(0,-1))}
              style={{padding:"8px 12px",borderRadius:9,background:"#ef444415",border:"1px solid #ef444430",color:"#ef4444",fontSize:13,fontWeight:700,cursor:"pointer"}}>− Retirer</button>
            <button onClick={save} disabled={saving}
              style={{padding:"8px 16px",borderRadius:9,background:saved?T.success:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
              {saving?"⏳":saved?"✅ Sauvegardé":"💾 Sauvegarder"}
            </button>
            <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
          </div>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"12px 22px"}}>
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{position:"sticky",top:0,zIndex:2}}>
                  {["CAM","Zone / Nom","Localisation","Type","IP / HDCVI","Notes"].map(h2=>(
                    <th key={h2} style={{background:T.sidebar,padding:"9px 10px",fontWeight:700,color:T.text,textAlign:"left",border:`1px solid ${T.border}`,whiteSpace:"nowrap",fontSize:11}}>{h2}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {cameras.map((cam,idx)=>{
                  const filled = cam.zone||cam.localisation;
                  return(
                    <tr key={idx} style={{background:filled?`${T.accent}08`:idx%2===0?T.bg:T.card}}>
                      <td style={{padding:"6px 10px",border:`1px solid ${T.border}`,fontWeight:800,color:T.accent,fontSize:14,textAlign:"center",whiteSpace:"nowrap"}}>
                        #{cam.numero_camera}
                      </td>
                      <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                        <input value={cam.zone||""} onChange={e=>upCam(idx,"zone",e.target.value)} placeholder="Ex: Hall entrée"
                          style={{background:"transparent",border:"none",outline:"none",color:T.text,fontSize:12,width:"100%",minWidth:120}}/>
                      </td>
                      <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                        <input value={cam.localisation||""} onChange={e=>upCam(idx,"localisation",e.target.value)} placeholder="Plafond, mur nord..."
                          style={{background:"transparent",border:"none",outline:"none",color:T.text,fontSize:12,width:"100%",minWidth:120}}/>
                      </td>
                      <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                        <select value={cam.type_camera||""} onChange={e=>upCam(idx,"type_camera",e.target.value)}
                          style={{background:T.bg,border:"none",borderRadius:5,padding:"4px 6px",color:T.text,fontSize:11,outline:"none",cursor:"pointer"}}>
                          <option value="">—</option>
                          {TYPES_CAM.map(t=><option key={t} value={t}>{t}</option>)}
                        </select>
                      </td>
                      <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                        <div style={{display:"flex",alignItems:"center",gap:6}}>
                          <input value={cam.ip||""} onChange={e=>upCam(idx,"ip",e.target.value)} placeholder="192.168.x.x"
                            style={{background:"transparent",border:"none",outline:"none",color:T.text,fontSize:11,width:90,fontFamily:"monospace"}}/>
                          <label style={{display:"flex",alignItems:"center",gap:4,fontSize:10,color:T.muted,cursor:"pointer",whiteSpace:"nowrap"}}>
                            <input type="checkbox" checked={cam.hdcvi||false} onChange={e=>upCam(idx,"hdcvi",e.target.checked)} style={{accentColor:T.accent}}/>
                            HDCVI
                          </label>
                        </div>
                      </td>
                      <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                        <input value={cam.notes||""} onChange={e=>upCam(idx,"notes",e.target.value)} placeholder="Observations..."
                          style={{background:"transparent",border:"none",outline:"none",color:T.text,fontSize:11,width:"100%",minWidth:80}}/>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
